import { render, staticRenderFns } from "./PolitiqueConfidentialite.vue?vue&type=template&id=3118a51e&scoped=true&"
import script from "./PolitiqueConfidentialite.vue?vue&type=script&lang=js&"
export * from "./PolitiqueConfidentialite.vue?vue&type=script&lang=js&"
import style0 from "./PolitiqueConfidentialite.vue?vue&type=style&index=0&id=3118a51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3118a51e",
  null
  
)

export default component.exports